import { UiItem } from "@/src/data/allTypes";
import { uid } from "@/src/utils/utils";
import { useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";

export function useAiWindowHook({ item }: { item: UiItem }) {
  const [uniqueId, setUniqueId] = useState(item.id || `${item.type}-${uid()}`);
  useEffect(() => {
    if (typeof window === "undefined") return;
    item.id = uniqueId;
    (window as any).items ||= {};
    (window as any).items[uniqueId] = converAllHtmlToText(item);

    return () => {
      delete (window as any).items[uniqueId];
    };
  }, []);
  return { uniqueId, item };
}

export function getHtmlFromElement(element: any): any {
  if (typeof element === "object" && element?.$$typeof != null) { 
    try {
      let html = ReactDOMServer.renderToStaticMarkup(element);
      let text = html.replace(/<[^>]*>?/g, "");
      return text;
    } catch (e) {
      return null;
    }
  }
  if (Array.isArray(element) && element[0]?.$$typeof != null)
    return element.map((item: any) => getHtmlFromElement(item)).join("\n");

  return element;
}

export function converAllHtmlToText(obj: any) {
  for (let key in obj) {
    obj[key] = getHtmlFromElement(obj[key]);
  }
  return obj;
}
